export default __webpack_public_path__ + "static/media/ptx_biz_logo.f1968c7a.png";